import { Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '@app/settings.service';
import { PanelComponent } from '@app/shared/panel/panel.component';
import { Subject } from 'rxjs';
import { AuthorizationComponent } from './authorization/authorization.component';
import { EnterCodeComponent } from './enter-code/enter-code.component';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CreateNewPasswordComponent } from './create-new-password/create-new-password.component';

export type TypeStep = 'login' | 'code' | 'authorization' | 'registration' | 'resetPassword' | 'confirmResetPassword' | 'createNewPassword' |'closeAll';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  standalone: true,
  imports: [PanelComponent, AuthorizationComponent, CreateNewPasswordComponent, RegistrationComponent, EnterCodeComponent, LoginComponent, ResetPasswordComponent],
})
export class SignUpComponent implements OnInit, OnDestroy {
  authorizationForm: FormGroup;
  loginForm: FormGroup;
  destroy$: Subject<void> = new Subject<void>();
  currentLanguageAsKey = this._settingsService.getCurrentLanguageAsKey();
  openPanel = true;
  isSendPhone = false;
  currentlyStep: TypeStep = 'login';
  titleSteps: { login: string; code: string; authorization: string; registration: string; resetPassword: string; confirmResetPassword: string; createNewPassword: string } = {
    login: 'Войти или зарегистрироваться',
    code: 'Вам отправлен код. Введите его.',
    authorization: 'Авторизация',
    registration: 'Регистрация',
    resetPassword: 'Восстановление пароля',
    confirmResetPassword: 'Укажите верификационный код, отправленный на указанный номер телефона',
    createNewPassword: 'Придумайте пароль',
  };
  token: string;
  steps: {
    login: TemplateRef<any>;
    code: TemplateRef<any>;
    authorization: TemplateRef<any>;
    registration: TemplateRef<any>;
    resetPassword: TemplateRef<any>;
    confirmResetPassword: TemplateRef<any>;
    createNewPassword: TemplateRef<any>;
  };

  @ViewChild('stepLogin', { static: true }) stepLogin!: TemplateRef<any>;
  @ViewChild('stepCode', { static: true }) stepCode!: TemplateRef<any>;
  @ViewChild('stepAuthorization', { static: true }) stepAuthorization!: TemplateRef<any>;
  @ViewChild('stepRegistration', { static: true }) stepRegistration!: TemplateRef<any>;
  @ViewChild('stepResetPassword', { static: true }) stepResetPassword!: TemplateRef<any>;
  @ViewChild('stepConfirmResetPassword', { static: true }) stepConfirmResetPassword!: TemplateRef<any>;
  @ViewChild('stepCreateNewPassword', { static: true }) stepCreateNewPassword!: TemplateRef<any>;
  @Output() visiblePanelChange = new EventEmitter<boolean>();
  constructor(private _settingsService: SettingsService) {}

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      login: new FormControl<string>(null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
    });

    this.authorizationForm = new FormGroup({
      login: new FormControl<string>(null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
      password: new FormControl<string>(null, [Validators.required]),
    });

    this.steps = {
      login: this.stepLogin,
      code: this.stepCode,
      authorization: this.stepAuthorization,
      registration: this.stepRegistration,
      resetPassword: this.stepResetPassword,
      confirmResetPassword: this.stepConfirmResetPassword,
      createNewPassword: this.stepCreateNewPassword,
    };
  }

  putToken(token: string) {
    this.token = token;
  }

  visibleChange(event: any) {
    this.visiblePanelChange.emit(event);
  }

  changeStep(step: TypeStep) {
    if (step === 'closeAll') {
      this.visibleChange(false);
      return;
    }
    this.currentlyStep = step;
  }

  fetchPhone(event: any) {
    this.currentlyStep = event;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
